import React from 'react'
import pubs from './bibly.js'
import SkyLight from 'react-skylight';


class PubRow extends React.Component {
  _executeBeforeModalOpen(){
    console.log(this)
  }

  render() {
    const {title, linky, bibtex, authors, rest, afterword} = this.props;

    let afterword_el = null;
    if (afterword != ''){
      afterword_el = <span className="afterword">
      {afterword}
      </span>
    }

    return (
      <div key={title}>
        <SkyLight
          hideOnOverlayClicked
          beforeOpen={this._executeBeforeModalOpen}
          dialogStyles={ {height:'auto'} }
          ref="simpleDialog"
          title={title}>
          <div id="prewrap">
            {bibtex}
          </div>
        </SkyLight>
        <div className = "left-no-pad">
          <a href={linky}>PDF</a>
        </div>
        <div className = "left-tight">
          <span id="fake-link" onClick={() => this.refs.simpleDialog.show()}>
            BibTeX
          </span>
        </div>
        <div className = "right">
          <div className = "right-marge">
            <strong>{title}</strong>
            <br/>
            {authors}
            <br/>
            <span className="italic-span"> {rest} </span>
            {afterword_el}
          </div>
        </div>
      </div>
    );
  }
}

export default class Publist extends React.Component {
  render() {
    const publist = pubs.map((pub, i) =>
        <PubRow {... pub}
          key={pub.title} />
    );
    return (
      <div key='lol_pubslist'>
      {publist}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/publications.js